import React from 'react';
import "./IconCounter.scss";
import Tooltip from '../popups/Tooltip';

const IconCounter = (props) => {
	const { status, icon, count, tooltip, dataAvailable, inactive, iconOnly } = props;
	return (
		<Tooltip hoverOnly label={dataAvailable ? tooltip : "No Data Available"} disabled={!tooltip}>
			<div className={`icon-counter-wrapper icon-counter-status-${status}${inactive ? " counter-inactive" : ""}`}>
				{icon}
				{iconOnly ? "" : <div className="icon-counter-count">{dataAvailable ? count : <div className="icon-counter-empty">-</div>}</div>}
			</div>
		</Tooltip>
	);
}

export default IconCounter;